import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Navbar = (props) => {
  return (
    <nav
      className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}
    >
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <img
            src="favicon-32x32.png"
            alt="logo"
            className="d-inline-block align-text-top"
          ></img>{" "}
          <strong>{props.title}</strong>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" aria-current="page" to="/">
                <strong>Home</strong>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                <strong>About</strong>
              </Link>
            </li>
          </ul>
        </div>
        <div
          className={`form-check form-switch text-${
            props.mode === "light" ? "dark" : "light"
          }`}
        >
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id="flexSwitchCheckDefault"
            onClick={props.toggleMode}
            style={{ cursor: "pointer" }}
          />
          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
            <strong>
              Enable {props.mode === "light" ? "Dark" : "Light"} Mode
            </strong>
          </label>
        </div>
      </div>
    </nav>
  );
};

Navbar.prototype = { title: PropTypes.string.isRequired };

export default Navbar;
